<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailCommande.ligneCommandeAchat.title') }}
      </p>
    </header>
    <div class="card-content">
      <div class="columns level is-multiline">
        <div class="column is-6 level-left">
          <div class="columns pdl-10px">
            <form @submit.prevent="recherche()"
              class="column is-5 pdr-0 pdl-0">
              <b-input :placeholder="$t('general.button.search')"
                type="search"
                icon="magnify"
                v-model="criteresRecherche.auto">
              </b-input>
            </form>
            <div class="column is-narrow">
              <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">{{$t('listeCommandes.actions.filtre')}}
                  <label class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span @click="reinitialiser()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <v-server-table
            url=""
            :columns="columns"
            :options="options"
            :ref="referenceTable"
            @loaded="finLoading"
            @loading="debutLoading">
            <template #afterTable>
              <table-items-in-view
                @input="$refs[referenceTable].setLimit($event)"/>
            </template>
            <template #codeCommande="{ row }">
              <router-link-blank
                :to="{ name: 'c.achat.commandes', params: { id: row.devisCommandeId } }"
                :message="row.devisCommande.code">
              </router-link-blank>
            </template>
            <template #libelleProduit="{ row }">
              {{ row.produit.libelle }}
            </template>
            <template #libelle="{ row }">
              {{ row.libelle }}
            </template>
            <template #listeIntervenants="{ row }">
              {{ getFournisseur(row.devisCommande.intervenants) }}
            </template>
            <template #etat="{ row }">
              {{ getEtatLibelle(row) }}
            </template>
            <template #quantite="{ row }">
              <div class="is-pulled-right">
                {{ row.quantite }}
              </div>
            </template>
            <template #prixUnitaire="{ row }">
              <div class="is-pulled-right">
                {{ func.formatDevise(row.prixUnitaire) }}
              </div>
            </template>
            <template #totalHt="{ row }">
              <div class="is-pulled-right">
                {{ func.formatDevise(row.totalHt) }}
              </div>
            </template>
          </v-server-table>
        </div>
      </div>
    </div>
    <transition name="custom-classes-transition"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-lignes-commande-achat
          ref="filtreListeLigneCommande"
          :nameStore="nameStore"
          @recherche="makeRechercheFilter()"
          @toggleFiltre="changeValueShowFiltreAndLockMenu()">
        </filtre-lignes-commande-achat>
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import { REFERENCE_TABLE_LIGNES_CMDES_ACHAT_CV } from '@/configuration/general/referenceTableConf';
import filtreLignesCommandeAchat from '@/components/commande/detail/ligneCommandeAchat/filtreLignesCommandeAchat';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { formatDevise } from '@/services/general/filters/formatDevise';
import RouterLinkBlank from '@/components/general/routerLinkBlank';
import { INCLUSION_LIGNE_LIEU_DE_LIVRAISON } from '@/configuration/dcf/dcfConf';
import { COMMANDE_ACHAT_FOURNISSEUR_ETAT, ETAT_COMMANDE } from '@/configuration/devisConf';
import getEtatTypeCommandeAchat from '@/services/achat/getEtatTypeCommandeAchat';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'LLignesCommandeAchat',
  props: {
    nameStore: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      referenceTable: REFERENCE_TABLE_LIGNES_CMDES_ACHAT_CV,
      showFiltre: false,
      func: {
        formatDevise,
      },
      inclusions: [
        { value: INCLUSION_LIGNE_LIEU_DE_LIVRAISON },
      ],
    };
  },
  components: {
    TableItemsInView,
    filtreLignesCommandeAchat,
    RouterLinkBlank,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    criteresRecherche: {
      get() {
        return this.$store.getters[`${this.nameStore}/criteresRechercheAchats`];
      },
      set(value) {
        this.$store.commit(`${this.nameStore}/SET_CRITERE_ACHATS`, value);
      },
    },
    items() {
      return this.$store.getters[`${this.nameStore}/items`];
    },
    totalCount() {
      return this.$store.getters[`${this.nameStore}/totalCount`];
    },
    nombreCritere() {
      const banCritere = ['auto', 'typesDevisCommandeFacture', 'types', 'societeId',
        'sens', 'module', 'typeReferenceExterne', 'referenceExterne', 'etatsDevisCommandeFacture',
        'sousTypes',
      ];
      const nbCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columnsData() {
      return [
        { name: 'codeCommande', sortable: true },
        { name: 'libelleProduit', sortable: true },
        { name: 'libelle', sortable: true },
        { name: 'listeIntervenants', sortable: false },
        { name: 'etat', sortable: false },
        { name: 'quantite', sortable: true },
        { name: 'prixUnitaire', sortable: true },
        { name: 'totalHt', sortable: true },
      ];
    },
    columns() {
      return this.columnsData.map((column) => column.name);
    },
    options() {
      const headings = this.columnsData.reduce((acc, val) => {
        acc[val.name] = this.$t(`detailCommande.ligneCommandeAchat.tab.${val.name}`) ?? '';
        return acc;
      }, {});
      return {
        sortIcon: SORT_ICON,
        headings,
        filterable: false,
        sortable: this.columnsData.filter((c) => c.sortable).map((c) => c.name),
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          listeIntervenants: 'ellipsis colonneListeIntervenants',
        },
        requestFunction: ((data) => {
          data.inclusion = this.inclusions.map(el => el.value);
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.tiersId = tagInputToArray(this.criteresRecherche.tiersId, 'id');
          data.query.produitsIds = tagInputToArray(this.criteresRecherche.produitsIds, 'id');
          data.query.societeId = this.societeActiveId;
          data.query.referenceExterne = this.$route.params.id;
          return this.actionLoadLigneCommande(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
      };
    },
  },
  methods: {
    actionLoadLigneCommande(data) {
      return this.$store.dispatch(`${this.nameStore}/loadLigneCommande`, data);
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeLigneCommande.initializeFiltre();
    },
    async reinitialiser() {
      await this.$refs.filtreListeLigneCommande.initializeFiltre();
      this.$refs.filtreListeLigneCommande.viderCritere();
      this.$refs.filtreListeLigneCommande.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    getEtatLibelle(ligne) {
      const etat = getEtatTypeCommandeAchat(ligne.lieuxLivraisons, ligne.devisCommande.etat);
      let etatTrad = '';
      if (etat === ETAT_COMMANDE) {
        etatTrad = this.$t('editionCommande.logistiqueImpression.etat.commande');
      } else {
        const find = COMMANDE_ACHAT_FOURNISSEUR_ETAT.find((el) => el.code === etat);
        etatTrad = find ? this.$t(find.libelle) : '';
      }
      return etatTrad;
    },
    getFournisseur(intervenants) {
      return intervenants.map((intervenant) => intervenant.nomCommercial).join(', ');
    },
  },
};
</script>
